import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { EmpresaService } from '@shared/service/app/empresa.service';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
    private currentTitle: string | undefined;

    constructor(
        private readonly title: Title,
        private empresaService: EmpresaService
    ) {
        super();
        this.empresaService.empresa$.subscribe(empresa => {
            if (empresa && empresa.razon_social) {
                const razonSocial = empresa.razon_social;
                if (this.currentTitle !== undefined) {
                    let formattedTitle = this.currentTitle;
                    if (formattedTitle.includes(' / ')) {
                        formattedTitle = formattedTitle.split(' / ')[0];
                    }
                    if (formattedTitle === 'Inicio de Sesión') {
                        this.title.setTitle(formattedTitle);
                    } else {
                        this.title.setTitle(`${formattedTitle} - ${razonSocial}`);
                    }
                } else {
                    this.title.setTitle(razonSocial);
                }
            }
        });
    }

    override updateTitle(routerState: RouterStateSnapshot): void {
        this.currentTitle = this.buildTitle(routerState);
        const razonSocial = this.empresaService.datosEmpresa?.razon_social || 'Jedstion';

        if (this.currentTitle !== undefined) {
            let formattedTitle = this.currentTitle;
            if (formattedTitle.includes(' / ')) {
                formattedTitle = formattedTitle.split(' / ')[0];
            }
            if (formattedTitle === 'Inicio de Sesión') {
                this.title.setTitle(formattedTitle);
            } else {
                this.title.setTitle(`${formattedTitle} - ${razonSocial}`);
            }
        } else {
            this.title.setTitle(razonSocial);
        }
    }
}
